<template>
    <div style="background-color: #f5f5f5f5">   
        <header id="header" class="header header-hide">
          <b-navbar toggleable="sm" type="light" style="padding: 0">
            <b-container style="background-color: white;padding: 8px 16px">
              <b-navbar-brand id="logo">
                <a href="#body" class="scrollto"><span>Nefro</span>Atlas</a>
              </b-navbar-brand>

              <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

              <b-collapse id="nav-text-collapse" is-nav>
                <b-navbar-nav class="ml-auto nav-menu">
                  <li>
                    <router-link class="active" to="/">
                      Home 
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/about">
                      Sobre
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/login">
                      login <span> <log-in-icon size="1x"></log-in-icon> </span>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/cadastro">
                      Cadastro <span> <user-plus-icon size="1x"></user-plus-icon> </span>
                    </router-link>
                  </li>
                </b-navbar-nav>
              </b-collapse>
            </b-container>
          </b-navbar>
        </header>

        <!--==========================
            Autores Section
        ============================-->

        <b-container fluid>    
            <b-container style="padding-bottom: 64px; padding-top: 90px">
                <b-row align-h="center" align-v="center">
                    <b-col cols="12" md="12" style="padding: 0">
                        <h1 class="text-center" style="padding-bottom: 32px">Autores</h1>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Felipe Leite Guedes
                                </h3>
                                <p class="funcao">
                                    Autor
                                </p>
                                <p>
                                    Mestrando em Ensino na Saúde <br>
                                    Preceptor dos Programas de Residência Médica em Clínica Médica e Nefrologia <br>
                                    Preceptor do Estágio Supervisionado em Clínica Médica (UFRN) <br>
                                    Nefrologista do Hospital Universitário Onofre Lopes <br>
                                    Nefrologista pela Universidade de São Paulo – titulado pela Sociedade Brasileira de Nefrologia <br>
                                </p>
                                
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Gyl Eanes Barros da Silva
                                </h3>
                                <p class="funcao">
                                    Autor
                                </p>
                                <p>
                                    Mestre e Doutor em Patologia pela Universidade de São Paulo <br>
                                    Professor livre-docente em Patologia da UFMA <br>
                                    Patologista responsável pelo Laboratório de Patologia da UFMA <br>
                                </p>
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Prof Dr José Diniz Júnior
                                </h3>
                                <p class="funcao">
                                    Orientador
                                </p>
                                <p>
                                    Professor orientador do Mestrado Profissional em Ensino na Saúde <br>
                                    Chefe da Unidade de Telessaúde da EBSERH e RUTE (Rede Universitária da Telemedicina)<br>
                                    Mestrado e Doutorado em Medicina (Otorrinolaringologia) pela Unifesp<br>
                                    Fellow Faimer Brasil – Especialização em desenvolvimento docente nas profissões da saúde<br>
                                    Professor Adjunto I do Curso de Medicina<br>
                                    Supervisor do Programa de Residência Médica em Otorrinolaringologia, Preceptor da Residência Multiprofissional (Buco-maxilo) e da Medicina de Família
                                </p>
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Profa Dra Anna Giselle Dantas Ribeiro Rodrigues
                                </h3>
                                <p class="funcao">
                                    Orientador
                                </p>
                                <p>
                                    Pós-doutorado em Engenharia Médica na UFRN / UNIFESP <br>
                                    Doutorado em Engenharia Elétrica e de Computação pela UFRN / MIT Division od Health Science and Technology Havard <br>
                                    Professora Adjunta no Instituto Metrópole Digiral – UFRN
                                </p>
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Kessia Larissa de Medeiros Quirino
                                </h3>
                                <p class="funcao">
                                    Colaborador
                                </p>
                                <p>
                                    Mestre em Ensino na Saúde (UFRN) <br>
                                    Médica nefrologista pela UFRN
                                </p>
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Leonardo Goulart
                                </h3>
                                <p class="funcao">
                                    Desenvolvimento FrontEnd 
                                </p>
                                <p>
                                    Bacharelando em Tecnologia da Informação 
                                </p>
                            </b-col>
                        </b-row>

                        <b-row style="padding-bottom: 20px" align-h="center">
                            <b-col sm="12" md="2" class="text-center" style="min-height: 150px; margin-bottom: 20px;">
                                <!-- <img src="../assets/autores/teste.jpg" width="150" alt="autor" class="middle"> -->
                            </b-col>
                            <b-col sm="12" md="7">
                                <h3>
                                    Arthur Cohen
                                </h3>
                                <p class="funcao">
                                    Desenvolvimento BackEnd 
                                </p>
                                <p>
                                    Bacharelando em Tecnologia da Informação 
                                </p>
                            </b-col>
                        </b-row>

                        

                    </b-col>
                </b-row>
            </b-container>
        </b-container>

        <!--==========================
            Contact Section
        ============================-->
        <section id="contact" class="padd-section wow fadeInUp" style="padding-top: 32px">

            <div class="container">
                <div class="section-title text-center">
                    <h2>Contato</h2>
                    <p class="separator">Entre em contato para saber mais sobre nossa plataforma. Comece hoje seus estudos <router-link to="cadastro">cadastrar</router-link></p>
                </div>
            </div>

            <div class="container">
              <div class="row justify-content-center">

                  <div class="col-lg-3 col-md-4">

                    <img src="../assets/logo.png" alt="logo">

                  </div>

                  <div class="col-lg-5 col-md-8">
                    <div class="form">
                        <div id="sendmessage">Your message has been sent. Thank you!</div>
                        <div id="errormessage"></div>
                        <form action="" method="post" role="form" class="contactForm">
                        <div class="form-group">
                            <input type="text" name="name" class="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
                            <div class="validation"></div>
                        </div>
                        <div class="form-group">
                            <textarea class="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
                            <div class="validation"></div>
                        </div>
                        <div class="text-center"><button type="submit">Send Message</button></div>
                        </form>
                    </div>
                  </div>
              </div>
            </div>
        </section><!-- #contact -->

        <!--==========================
            Footer
        ============================-->
        <footer class="footer">
            <div class="container">
            <div class="row">

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      <a class="navbar-brand" href="#"><span class="nefro">NEFRO</span><span class="atlas">ATLAS</span></a>
                      <h4 style="color:white">Tire suas dúvidas!</h4>
                      <p class="text-justify">
                        Em qualquer momento dos seus estudos, nossa equipe poderá receber suas dúvidas através
                        do e-mail localizado na parte inferior desta página.
                      </p>

                  </div>
                </div>

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      

                  </div>
                </div>

                <div class="col-md-12 col-lg-4">
                  <div class="footer-logo">

                      <a href="" class="navbar-brand"></a>

                      <h4 style="color:white">Faça nossas questões!</h4>
                      <p class="text-justify">
                        Ao final de cada módulo teremos questões de exercício, com o único objetivo de promover a
                        auto-avaliação e ser utilizada como ferramenta para a aprendizagem. Não deixe de fazer
                        nossos exercícios!
                      </p>

                  </div>
                </div>



                <!-- <div class="col-sm-6 col-md-3 col-lg-2">
                  <div class="list-menu">

                      <h4>Abou Us</h4>

                      <ul class="list-unstyled">
                      <li><a href="#">About us</a></li>
                      <li><a href="#">Features item</a></li>
                      <li><a href="#">Live streaming</a></li>
                      <li><a href="#">Privacy Policy</a></li>
                      </ul>

                  </div>
                </div>

                <div class="col-sm-6 col-md-3 col-lg-2">
                  <div class="list-menu">

                      <h4>Support</h4>

                      <ul class="list-unstyled">
                      <li><a href="#">faq</a></li>
                      <li><a href="#">Editor help</a></li>
                      <li><a href="#">Contact us</a></li>
                      <li><a href="#">Privacy Policy</a></li>
                      </ul>

                  </div>
                </div> -->


            </div>
            </div>

            <div class="copyrights">
              <div class="container">
                  <p>2019 &copy; Copyrights <span class="nefro">Nefro</span><span class="atlas">Atlas</span>. All rights reserved.</p>
              </div>
            </div>

        </footer>



        <a href="#" class="back-to-top"><i class="fa fa-chevron-up"></i></a>



    </div>
</template>

<script>
import { LogInIcon, UserPlusIcon } from 'vue-feather-icons'
export default {
    components: {
      LogInIcon,
      UserPlusIcon
    }
}
</script>

<style scoped>

@charset "UTF-8";

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
.header-hide {
    /* background-color: #f5f5f5f5!important; */
    height: 63px!important;
}
  body {
    background-color: #fff;
    color: #333;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  h2 {
    color: #000;
    font-weight: 100;
  }

  h4 {
    color: #000;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    line-height: 2;
  }

  h5 {
    color: #626262;
    font-size: 14px;
    font-weight: 500;
  }

  a {
    letter-spacing: 2px;
    text-decoration: none;
  }

  ul {
    letter-spacing: 1px;
  }

  li {
    color: #626262;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 2px;
    line-height: 30px;
    text-transform: capitalize;
  }

  p {
    color: #505050;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 2;
    margin-bottom: 20px;
  }

  span {
    letter-spacing: 1px;
  }

    .funcao {
    font-size: 16px;
    font-weight: 800
}
.middle {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
}

  .img-fluid {
    height: 60px;
    margin-bottom: 30px;
    width: 60px;
  }

  .container-full {
    padding-left: 0;
    padding-right: 0;
  }

  .btn {
    border: 1px solid #fff;
    border-radius: 50px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 15px 40px;
    text-transform: uppercase;
    -moz-transition: all 0.5s ease-in-out 0s;
    -ms-transition: all 0.5s ease-in-out 0s;
    -o-transition: all 0.5s ease-in-out 0s;
    -webkit-transition: all 0.5s ease-in-out 0s;
    transition: all 0.5s ease-in-out 0s;
  }

  .btn-default:hover {
    color: #fff;
    background-color: #e6e6e6;
    border-color: #adadad;
  }

  /* Back to top button */
  .back-to-top {
    position: fixed;
    display: none;
    background: #71c55d;
    line-height: 1;
    color: #fff;
    padding: 7px 12px 13px 12px;
    font-size: 16px;
    border-radius: 2px;
    right: 15px;
    bottom: 15px;
    transition: background 0.5s;
  }

  @media (max-width: 768px) {
    .back-to-top {
      bottom: 15px;
    }
  }

  .back-to-top:focus {
    background: #71c55d;
    color: #fff;
    outline: none;
  }

  .back-to-top:hover {
    background: #55b03f;
    color: #fff;
  }

  /*--------------------------------------------------------------
  # Header
  --------------------------------------------------------------*/
  #header {
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 48px;
    z-index: 3;
    transition: all 0.5s ease;
  }

  #header #logo {
    padding: 6px 0 0 0;
  }

  #header #logo {
    color: #505050;
    font-family: "Philosopher", sans-serif;
    font-size: 26px;
    font-weight: 500;
    letter-spacing: 1px;
    margin: 0;
  }

  #header #logo a {
    color: #41ce8e ;
    line-height: 1;
    display: inline-block;
    text-decoration: none;
  }
  .active {
     color: #41ce8e!important; 
  }

  #header #logo a span {
    color: #2cb5e8;
  }

  #header #logo img {
    padding: 0;
    margin: 0;
  }

  .scroll-header {
    background: #fff;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.1);
  }


/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/* Nav Menu Essentials */
.nav-menu, .nav-menu * {
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: white
}

.nav-menu ul {
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  z-index: 99;
}

.nav-menu li {
  position: relative;
  white-space: nowrap;
}

.nav-menu > li {
  float: left;
}

.nav-menu li:hover > ul,
.nav-menu li.sfHover > ul {
  display: block;
}

.nav-menu ul ul {
  top: 0;
  left: 100%;
}

.nav-menu ul li {
  min-width: 180px;
}


/* Nav Meu Container */
#nav-menu-container {
  position: relative;
  float: right;
  top: -40px;
  margin: 0 0 0 0;
}

@media (max-width: 1024px) {
  #nav-menu-container {
    display: initial;
  }
}

/* Nav Meu Styling */
.nav-menu a {
  padding: 8px 8px;
  text-decoration: none;
  display: inline-block;
  color: #555;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 14px;
  outline: none;
  letter-spacing: 0;
  transition: 0.3s;
}

.nav-menu li:hover > a, .nav-menu > .menu-active > a {
  color: #71c55d;
}

.nav-menu > li {
  margin-left: 10px;
}

.nav-menu ul {
  margin: 0;
  padding: 10px;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  background: #fff;
}

.nav-menu ul li {
  transition: 0.3s;
}

.nav-menu ul li a {
  padding: 5px 10px;
  color: #333;
  transition: 0.3s;
  display: block;
  font-size: 14px;
  text-transform: none;
}

.nav-menu ul li:hover > a {
  color: #71c55d;
}

.nav-menu ul ul {
  margin: 0;
}


/*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/
.padd-section {
  padding-bottom: 80px;
  /* padding-top: 80px; */
}

@media (max-width: 992px) {
  .padd-section {
    padding-top: 40px;
    /* padding-bottom: 40px; */
  }
}

.section-title {
  margin-bottom: 80px;
}

@media (max-width: 992px) {
  .section-title {
    margin-bottom: 40px;
  }
}

.section-title h2 {
  font-family: "Roboto", sans-serif;
  font-size: 45px;
  font-weight: 100;
  letter-spacing: 2px;
  margin-bottom: 20px;
  text-transform: capitalize;
}

.section-title .separator {
  margin: 0;
}

.separator {
  color: #626262;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 300;
  margin-bottom: 30px;
  text-transform: capitalize;
}


/* Contact Section
--------------------------------*/
#contact {
  background: #fff;
}

#contact .info {
  color: #222;
}

#contact .info i {
  font-size: 32px;
  color: #71c55d;
  float: left;
}

#contact .info p {
  padding: 0 0 10px 50px;
  margin-bottom: 20px;
  line-height: 22px;
  font-size: 14px;
}

#contact .info .email p {
  padding-top: 5px;
}

#contact .social-links {
  padding-bottom: 20px;
}

#contact .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #71c55d;
  color: #fff;
  line-height: 1;
  padding: 6px 0 8px 0;
  border-radius: 50%;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}

#contact .social-links a:hover {
  background: #55b03f;
  color: #fff;
}

#contact .form #sendmessage {
  color: #71c55d;
  border: 1px solid #71c55d;
  display: none;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #errormessage {
  color: red;
  display: none;
  border: 1px solid red;
  text-align: center;
  padding: 15px;
  font-weight: 600;
  margin-bottom: 15px;
}

#contact .form #sendmessage.show, #contact .form #errormessage.show, #contact .form .show {
  display: block;
}

#contact .form .validation {
  color: red;
  display: none;
  margin: 0 0 20px;
  font-weight: 400;
  font-size: 13px;
}

#contact .form input, #contact .form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  padding: 12px 10px;
  line-height: 1;
}

#contact .form button[type="submit"] {
  background: #71c55d;
  border: 0;
  padding: 10px 24px;
  color: #fff;
  transition: 0.4s;
}

#contact .form button[type="submit"]:hover {
  background: #92d283;
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer {
  background: #2a2c30;
  padding-top: 50px;
}

.footer .footer-logo .navbar-brand {
  color: #fff;
  display: inline-block;
  float: none;
  font-family: "Philosopher", sans-serif;
  font-size: 24px;
  font-weight: 500;
  height: 100%;
  letter-spacing: 0.2em;
  padding-left: 0;
  padding-top: 0;
}

.footer .footer-logo p {
  color: #fff;
  font-size: 12px;
  letter-spacing: 1px;
}

.footer .list-menu > h4 {
  color: #fff;
  padding-bottom: 20px;
}

.footer .list-menu ul li a {
  color: #fff;
  font-size: 12px;
  padding-left: 5px;
  text-decoration: none;
  letter-spacing: 0;
}

.footer .copyrights {
  background: #fff;
  margin-top: 50px;
  text-align: center;
  padding: 25px;
}

.footer .copyrights p, .footer .copyrights .credits {
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0;
}

.footer .copyrights p a, .footer .copyrights .credits a {
  letter-spacing: 0;
  color: #71c55d;
}



</style>